export const spotifyDiscoveryConstants = {
	GET_SPOTIFY_DISCOVERY_REQUEST: 'GET_SPOTIFY_DISCOVERY_REQUEST',
	GET_SPOTIFY_DISCOVERY_SUCCESS: 'GET_SPOTIFY_DISCOVERY_SUCCESS',
	GET_SPOTIFY_DISCOVERY_FAILURE: 'GET_SPOTIFY_DISCOVERY_FAILURE',
	GET_SPOTIFY_DISCOVERY_TOTALS_REQUEST: 'GET_SPOTIFY_DISCOVERY_TOTALS_REQUEST',
	GET_SPOTIFY_DISCOVERY_TOTALS_SUCCESS: 'GET_SPOTIFY_DISCOVERY_TOTALS_SUCCESS',
	GET_SPOTIFY_DISCOVERY_TOTALS_FAILURE: 'GET_SPOTIFY_DISCOVERY_TOTALS_FAILURE',
	GET_SPOTIFY_DISCOVERY_TIMESERIES_REQUEST: 'GET_SPOTIFY_DISCOVERY_TIMESERIES_REQUEST',
	GET_SPOTIFY_DISCOVERY_TIMESERIES_SUCCESS: 'GET_SPOTIFY_DISCOVERY_TIMESERIES_SUCCESS',
	GET_SPOTIFY_DISCOVERY_TIMESERIES_FAILURE: 'GET_SPOTIFY_DISCOVERY_TIMESERIES_FAILURE',
	GET_SPOTIFY_DISCOVERY_MAIN_TIMESERIES_REQUEST: 'GET_SPOTIFY_DISCOVERY_MAIN_TIMESERIES_REQUEST',
	GET_SPOTIFY_DISCOVERY_MAIN_TIMESERIES_SUCCESS: 'GET_SPOTIFY_DISCOVERY_MAIN_TIMESERIES_SUCCESS',
	GET_SPOTIFY_DISCOVERY_MAIN_TIMESERIES_FAILURE: 'GET_SPOTIFY_DISCOVERY_MAIN_TIMESERIES_FAILURE',
	GET_SPOTIFY_DISCOVERY_DETAILS_TIMESERIES_REQUEST: 'GET_SPOTIFY_DISCOVERY_DETAILS_TIMESERIES_REQUEST',
	GET_SPOTIFY_DISCOVERY_DETAILS_TIMESERIES_SUCCESS: 'GET_SPOTIFY_DISCOVERY_DETAILS_TIMESERIES_SUCCESS',
	GET_SPOTIFY_DISCOVERY_DETAILS_TIMESERIES_FAILURE: 'GET_SPOTIFY_DISCOVERY_DETAILS_TIMESERIES_FAILURE',
	RESET_SPOTIFY_DISCOVERY_DETAILS_TIMESERIES: 'RESET_SPOTIFY_DISCOVERY_DETAILS_TIMESERIES'
}